const STORAGE_KEY = "incite:active-chat-thread:v1";
const ACTIVE_THREAD_TTL_MS = 60 * 60 * 1000;

const now = () => Date.now();

const storage = () => {
  if (typeof window === "undefined") return null;

  try {
    return window.localStorage || null;
  } catch {
    return null;
  }
};

const normalizeThreadSnapshot = (thread) => {
  const threadUuid = thread?.threadUuid || thread?.thread_uuid || null;
  if (!threadUuid) return null;

  return {
    threadUuid,
    title: thread?.title || thread?.threadTitle || "Chat",
    savedAt: now(),
  };
};

export const isTempThreadUuid = (threadUuid) =>
  typeof threadUuid === "string" && threadUuid.startsWith("temp-");

export const rememberActiveChatThread = (thread) => {
  const snapshot = normalizeThreadSnapshot(thread);
  const store = storage();
  if (!snapshot || !store) return null;

  try {
    store.setItem(STORAGE_KEY, JSON.stringify(snapshot));
  } catch {
    // localStorage can be unavailable in private or restricted contexts.
  }

  return snapshot;
};

export const clearRememberedActiveChatThread = () => {
  const store = storage();
  if (!store) return;

  try {
    store.removeItem(STORAGE_KEY);
  } catch {
    // localStorage can be unavailable in private or restricted contexts.
  }
};

export const readRememberedActiveChatThread = () => {
  const store = storage();
  if (!store) return null;

  try {
    const raw = store.getItem(STORAGE_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    if (!parsed?.threadUuid || !parsed?.savedAt) {
      store.removeItem(STORAGE_KEY);
      return null;
    }

    if (now() - Number(parsed.savedAt) > ACTIVE_THREAD_TTL_MS) {
      store.removeItem(STORAGE_KEY);
      return null;
    }

    return parsed;
  } catch {
    try {
      store.removeItem(STORAGE_KEY);
    } catch {
      // localStorage can be unavailable in private or restricted contexts.
    }
    return null;
  }
};

export { ACTIVE_THREAD_TTL_MS };
